export function isNumeric(val) {
  return /^\d+(\.\d+)?$/.test(val);
}
export function isNaN(val) {
  if (Number.isNaN) {
    return Number.isNaN(val);
  } // eslint-disable-next-line no-self-compare


  return val !== val;
}


//////////////////
// WEBPACK FOOTER
// ./~/_vant@2.12.54@vant/es/utils/validate/number.js
// module id = 102
// module chunks = 41